export default __webpack_public_path__ + "static/media/kitchen-pack-15.5bdb4165.png";